import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { downloadLink } from '@/utils/helper';
import { $http } from '@/axios';
import store from '@/store';

// 查询模型列表
export const queryUeItemPage: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setUeItemPage', { ...state.ueItemPage, loading: true });
    const res: IPageData = await $http.post('/v1/ue/item/pagelist', payload);
    const { list: data, total, pageNum, pageSize } = res;
    commit('setUeItemPage', { data, total, pageNum, pageSize });
  } catch (e) {
    commit('setUeItemPage', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询模型详情
export const queryMeshDetail: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDetail', { data: null, loading: true });
    // const res = await $http.post('/baseinfo/ueitem/mesh', payload);
    const res = await $http.post('/v1/ue/mesh/detail', payload);
    commit('setDetail', { data: res, loading: false });
  } catch (e) {
    commit('setDetail', { data: null, loading: false });
  }
};

// 保存模型
export const saveMesh: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/baseinfo/ueitem/mesh/platformupdate', payload);
    await $http.post('/v1/ue/mesh/updateforplatform', payload);
    store.commit('common/setToast', { visible: true, text: '保存成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 下载静态模型
export const downloadMesh: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setDownloaded', true);
    // const res: string = await $http.post('/baseinfo/ueitem/mesh/download', payload);
    const res: string = await $http.post('/v1/ue/mesh/download', payload);
    await downloadLink(res, '.obj');
  } finally {
    commit('setDownloaded', false);
  }
};

// 查询角色详情
export const queryActorDetail: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDetail', { ...state.detail, loading: true });
    // const res = await $http.post('/baseinfo/ueitem/actor', payload);
    const res = await $http.post('/v1/ue/actor/detail', payload);
    commit('setDetail', { data: res });
  } catch (e) {
    commit('setDetail', { data: null });
  }
};

// 保存角色
export const saveActor: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/baseinfo/ueitem/actor/saveorupdate', payload);
    await $http.post('/v1/ue/actor/saveorupdate', payload);
    store.commit('common/setToast', { visible: true, text: '保存成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 静态材质关联关系补全
export const calcMeshRef: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/ue/texture/addbymeshoractor', { fullpath: payload });
    store.commit('common/setToast', { visible: true, text: '补全成功' });
  } finally {
    commit('setLoading', false);
  }
};
